export default __webpack_public_path__ + "static/media/kukBo.8af813b1.png";